import { ACTIONS } from '../actions';
import { pluginKey as typeAheadPluginKey } from '../key';
export var updateListError = function updateListError(errorInfo) {
  return function (state, dispatch) {
    var tr = state.tr;
    tr.setMeta(typeAheadPluginKey, {
      action: ACTIONS.UPDATE_LIST_ERROR,
      params: {
        errorInfo: errorInfo,
        items: []
      }
    });
    if (dispatch) {
      dispatch(tr);
    }
    return true;
  };
};